mutation CreateGeometryType(
    $bimClassID: ID!
    $geometryType: GeometryTypeRevisionInput!
) {
    createGeometryType(
        bimClassID: $bimClassID
        geometryType: $geometryType
    ) {
        errors {
            message
        }
        geometryType {
            id
        }
        geometryTypeRevision {
            id
        }
    }
}
